import { usePageTitle } from "hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import { StepDestination } from "views/foundation/broadcastMessage/Home/StepDestination";
import { StepEditMessage } from "views/foundation/broadcastMessage/Home/StepEditMessage";
import { StepManagement } from "views/foundation/broadcastMessage/Home/StepManagement";
import { StepResult } from "views/foundation/broadcastMessage/Home/StepResult";

export type BroadcastMessageStepProps = {
  canSave: boolean;
  setCanSave: (value: boolean) => void;
  goNextStep: () => void;
  goFirstStep: () => void;
};


export const BroadcastMessage: React.FC = () => {
  const { t } = useTranslation();

  usePageTitle(t("Enrollment.Common.Title"));

  return <StepManagement
    steps={
      [
        { name: t("BroadcastMessage.StepEdit.TabName"), enabled: false, visible: true, render: StepEditMessage },
        { name: t("BroadcastMessage.StepDestination.TabName"), enabled: false, visible: true, render: StepDestination },
        { name: t("BroadcastMessage.StepResult.TabName"), enabled: false, visible: true, render: StepResult },
      ]
    }
  />;
};